import React from "react";
import styles from "./Table.module.sass";
import Checkbox from "../../../../components/Checkbox";
import Row from "./Row";

const Table = ({ items, title, onEdit, onDelete, selectedTutors = [], onSelectTutor, onSelectAll }) => {
  // Calculer si tous les éléments sont sélectionnés
  const allSelected = items.length > 0 && items.every(item => selectedTutors.includes(item.id));

  const handleSelectAll = () => {
    if (onSelectAll) {
      onSelectAll(!allSelected);
    }
  };

  const handleSelectTutor = (id, isSelected) => {
    if (onSelectTutor) {
      onSelectTutor(id, isSelected);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.table}>
        <div className={styles.row}>
          <div className={styles.col}>
            <Checkbox
              className={styles.checkbox}
              value={allSelected}
              onChange={handleSelectAll}
            />
          </div>
          <div className={styles.col}>Tuteur</div>
          <div className={styles.col}>Email</div>
          <div className={styles.col}>Téléphone</div>
          <div className={styles.col}>Actions</div>
        </div>
        {items.map((x, index) => (
          <Row
            item={x}
            key={index}
            index={index}
            value={selectedTutors.includes(x.id)}
            onChange={(isChecked) => handleSelectTutor(x.id, isChecked)}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ))}
      </div>
    </div>
  );
};

export default Table;
